import React, { FC } from 'react';

import CheckIcon from '../../svg/main/Check';

import * as ST from './styled';

interface IRadioProps {
    value: string,
    label: string,
    isChecked?: boolean,
    disabled?: boolean,
    onClick: (id: string) => void,
}

const MultiCheckboxWithIcon: FC<IRadioProps> = ({
    value,
    label,
    isChecked,
    onClick,
    disabled,
    ...rest
}) => {
    const onClickHandler = () => {
        !disabled && onClick(value);
    };

    return (
        <ST.MultiCheckbox
            isChecked={isChecked}
            onClick={onClickHandler}
            disabled={disabled}
            {...rest}
        >
            {isChecked && <CheckIcon type={disabled ? 'gray' : 'white'}/>}
            {label}
        </ST.MultiCheckbox>
    );
};

export default MultiCheckboxWithIcon;
